// extracted by mini-css-extract-plugin
export default {"modal":"ActivityNotesModal_modal__qJYhr","modalContent":"ActivityNotesModal_modalContent__HNsKL","notesWrapper":"ActivityNotesModal_notesWrapper__PXY3Z"};